module.exports = __webpack_public_path__ + "static/img/home1.f8a682e7.png";